import { render, staticRenderFns } from "./bcText.vue?vue&type=template&id=1edc1884&"
import script from "./bcText.vue?vue&type=script&lang=js&"
export * from "./bcText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports